export default __webpack_public_path__ + "static/media/gm-icon.0559dca6.svg";